import { SxStyles } from '../../../../types';
import theme from '../../../../theme';
import { getResponsiveSize } from '../../../../utils';

const BLUR_SLIDER_ACCENT = '#1976d2';

export const BackgroundBlurIntensityControlSXStyles: SxStyles = {
  backgroundBlurIntensityControlContainer: {
    px: getResponsiveSize(16),
    pb: getResponsiveSize(12),
    [theme.breakpoints.media?.tablet!]: {
      px: getResponsiveSize(12),
      pb: getResponsiveSize(10),
    },
  },
  backgroundBlurIntensityControlSurface: {
    px: getResponsiveSize(12),
    py: getResponsiveSize(12),
    width: '100%',
    [theme.breakpoints.media?.tablet!]: {
      px: getResponsiveSize(10),
      py: getResponsiveSize(10),
    },
  },
  backgroundBlurIntensityControlHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: getResponsiveSize(8),
  },
  backgroundBlurIntensityControlLabel: {
    fontFamily: theme.typography.mainFontFamily,
    fontSize: theme.typography.fs12,
    color: theme.palette.mainControls?.subTitleColor,
  },
  backgroundBlurIntensityControlValue: {
    fontFamily: theme.typography.mainFontFamily,
    fontSize: theme.typography.fs12,
    color: BLUR_SLIDER_ACCENT,
  },
  backgroundBlurIntensityControlRow: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    columnGap: getResponsiveSize(10),
    width: '100%',
  },
  backgroundBlurIntensityControlIcon: {
    color: theme.palette.mainControls?.mainBlue,
    fontSize: getResponsiveSize(18),
  },
  backgroundBlurIntensityControlSlider: {
    py: getResponsiveSize(8),
    color: BLUR_SLIDER_ACCENT,
    '& .MuiSlider-track': {
      border: 'none',
      backgroundColor: BLUR_SLIDER_ACCENT,
    },
    '& .MuiSlider-thumb': {
      width: getResponsiveSize(14),
      height: getResponsiveSize(14),
      backgroundColor: BLUR_SLIDER_ACCENT,
      boxShadow: '0 0 0 4px rgba(25, 118, 210, 0.14)',
      '&:hover, &.Mui-focusVisible, &.Mui-active': {
        boxShadow: '0 0 0 6px rgba(25, 118, 210, 0.18)',
      },
    },
    '& .MuiSlider-rail': {
      backgroundColor: theme.palette.mainControls?.lightBlue,
      opacity: 1,
    },
  },
};
